export class MobileMenu {
    readonly otherProjectsId = 'menu-other-projects';

    public toggleOtherProjects(clickedButton: HTMLElement): boolean {
        const otherProjectList = this.getOtherProjectListElement();
        otherProjectList.classList.toggle('d-none');

        clickedButton.classList.toggle('arrow-dropdown-toggle-primary');
        clickedButton.classList.toggle('arrow-primary-top');
        clickedButton.classList.toggle('text-primary');
        clickedButton.classList.toggle('arrow-bottom');
        return false;
    }

    private getOtherProjectListElement(): HTMLElement {
        let otherProjects = document.getElementById(this.otherProjectsId);
        if (otherProjects instanceof HTMLElement) {
            return otherProjects;
        }
        console.error('Could not find the sub menu!');
    }
}
